module.exports = __webpack_public_path__ + "static/media/celabrate_white.160f4847.svg";